module.exports = __webpack_public_path__ + "assets/img/litsthr.29917479.png";